define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/UiUtil',
	'internal_util/StorageUtil',
	'internal_util/Configuration',
        
        'model/Error',
	'model/ErrorType',
	
	'model/Context',
	'state/UIState',
	'service/UIStateManager',
	'service/EventListenerRegistry',
	
	'view/ProviderInfoView',
	'view/NavigationView',
	'view/ActivationView',
	'view/ControlBarView',
	'view/bindings/BindingViewContainer',
	'view/ControlView',
	'view/TextView',
	'view/bindings/BindingButtonView',
	'view/bindings/BindingView',
	'identity/IdentityTransferView',
	'view/bindings/ConfirmationView',
	
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/BindingState_strings',
        'amdi18n-loader?!state/nls/AuthenticationOptionSelectionState_strings',
	
	'model/bindings/PasswordBindingType',
	'factory/BindingsFactory',
	'factory/CloudIdentityFactory',
	
	'@ecsec/base-libs/dist/webcrypto',
//	'@ecsec/base-libs/dist/util',
	'u2f-api-polyfill'
], function (
	Logger,
	Util,
	UiUtil,
	StorageUtil,
	Configuration,
        
        IdsError,
	ErrorType,
	
	Context,
	UIState,
	UIStateManager,
	EventListenerRegistry,
	
	ProviderInfoView,
	NavigationView,
	ActivationView,
	ControlBarView,
	BindingViewContainer,
	ControlView,
	TextView,
	BindingButtonView,
	BindingView,
	IdentityTransferView,
	ConfirmationView,
	
	CommonStrings,
	Strings,
        AuthOptStrings,
	
	PasswordBindingType,
	BindingsFactory,
	CloudIdentityFactory,
	
	webcrypto,
//	ecUtil,
	u2f
) {
	'use strict';

	/**
	 * ActivationState class
	 */
	function BindingState(uiStateManager) {
		
		function log(method, message, data) {
			Logger.log('BindingState', method, message, data);
		}
		
		let _state = null;
		const PASSWORD = "PASSWORD",
				FIDO_U2F = "FIDO/U2F",
				BROWSER_CRYPTOAPI = "Browser/CrpytoAPI";
		
		let _uiStateManager,
			_activationData,
			_providerInfoView = new ProviderInfoView(),
			_navigationView = new NavigationView(),
			_bindingViewContainer = new BindingViewContainer(),
			_controlBarView = new ControlBarView('skIdS_control-bar-identity-management'),
			
			_bindingView = new BindingView(function () {
                                    if (canProceed()) {
                                            next();
                                    }
                                },function(enabled){
                                    if (enabled) {
                                            _bindingViewContainer.showFIDOHint();
                                    } else {
                                            _bindingViewContainer.hideFIDOHint();
                                    }
			}),
			_fidoBindingTextView = (function () {
					let textView = new TextView();

					textView.addText(Strings.activate_fido);

					return textView;
				})(),
			_instructionsView = (function () {
					let textView = new TextView();

					textView.addText(Strings.follow_instructions);

					return textView;
				})(),
                        _successView = (function () {
					let textView = new TextView();

					textView.addText(Strings.transfer_success);

					return textView;
				})();

		let _binding,
			_isRemote = false;
		
		let _identityTransferView = new IdentityTransferView(),
			_confirmationView = new ConfirmationView();

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

		_navigationView.update(Strings.protect_cid);

                let _backButton = _controlBarView.addButton(CommonStrings.back, function () {
                    init();
		},0);
                _backButton.hide();

		let _nextButton = _controlBarView.addButton(CommonStrings.next, function () {
			if (canProceed()) {
				next();
			}
		});
		_nextButton.hide();
                
                let _cancelButton = _controlBarView.addButton(CommonStrings.abort, function () {
			_uiStateManager.change('identities_overview');
		});
                
//                let _manageButton = _controlBarView.addButton(AuthOptStrings.identity_management, function () {
//                    _uiStateManager.change('identities_overview');
//		},0);
//                _manageButton.hide();

		if (!('u2f' in window)) {
			_bindingView.disableFIDO();
		}
		
		_identityTransferView.setUrlVisible(false);

		UIState.call(this, 'binding');

                let lockScreen=false; //used to prevent switch to default, if timeout from FIDO and already in paring-mode
		
                // private methods
                
                function init() {
                    if (!lockScreen) {
                        toLocal();
                        _backButton.hide();
                        _nextButton.prop('disabled', false);
                        _bindingView.update();
                        _bindingViewContainer.hideFIDOHint();
                        _bindingViewContainer.changeContent(_bindingView);
                    }
                }
                
                function transferSuccessful() {
                    _nextButton.hide();
                    _backButton.hide();
                    _bindingView.update();
                    _bindingViewContainer.hideFIDOHint();
                    _bindingViewContainer.changeContent(_successView);
                    _navigationView.update(Strings.transfer_success_title);
		    _navigationView.setProgress(4);
		    
		    setTimeout(function(){
			_uiStateManager.change('identities_overview');
//			window.history.back();
		    },5000);
                }
		
		function toMobile() {
                    lockScreen = true;
                    _nextButton.hide();
                    pair();
                    _bindingViewContainer.showToLocal(toLocal);
		}
		function toLocal() {
                    lockScreen = false;
                    _uiStateManager.messageBrokerManager().close();
                    _nextButton.show();
                    _bindingViewContainer.changeContent(_bindingView);
                    _navigationView.update(Strings.protect_cid);
                    _bindingViewContainer.showToMobile(toMobile);
		}

		function errorOccurred(error) {
			_uiStateManager.change('error', error);
		}

		function canProceed() {
			if(_bindingView.isChecked()) {
				_state = FIDO_U2F;
			} else {
				_state = BROWSER_CRYPTOAPI;
			}
			switch(_state) {
				case PASSWORD:
					return _bindingView.checkInput();
					break;
				case FIDO_U2F:
					return _bindingView.checkInput();
					break;
				case BROWSER_CRYPTOAPI:
					return _bindingView.checkInput();
					break;
			}
			return false;
		}
		
		function next() {
			_nextButton.prop('disabled', true);
			switch(_state) {
				case PASSWORD:
					_binding = BindingsFactory.createPasswordBinding(_bindingView.getInput(), Util.randomString());
					finish(_binding);
					break;
				case FIDO_U2F:
					_bindingViewContainer.hideToLocal();
					_bindingViewContainer.hideToMobile();
					_bindingViewContainer.changeContent(_fidoBindingTextView);
					fido_getReg(function(bind){
						_binding = bind;
						finish(_binding);
					});
					break;
				case BROWSER_CRYPTOAPI:
					_bindingViewContainer.hideToLocal();
					_bindingViewContainer.hideToMobile();
					cryptoAPI_genKey(_bindingView.getInput(), function(data) {
						_binding = data;
						finish(_binding);
					});
					break;
			}
		}
		
		function finish(binding) {
			_bindingViewContainer.showLoadingIndicator();
			_nextButton.prop('disabled', true);
			if(_isRemote) {
				switch (binding.type()) {
					case "http://ws.skidentity.de/ci/binding/key/v1.0":
						switch(binding.origin()) {
							case "WebCrypto":
								sendWebCryptoKey(binding, finishRemote);
								break;
							case "FIDO/U2F":
								sendFidoU2F(binding, finishRemote);
								break;
						}
						break;
				}
			} else if(_uiStateManager.core().context() === Context.SERVICE_PROVIDER) {
				_activationData['binding'] = binding;
				_uiStateManager.change('activation', _activationData);
			} else {
				_uiStateManager.core().cloudIdentitiesManager().getCloudIdentity(_activationData['session'], binding, binding.secret(), function (result) {
						if (_uiStateManager.core().contextChangeable()) {
							_uiStateManager.core().cloudIdentitiesManager().addCloudIdentity(result.identity);
							_uiStateManager.changeContext();
						} else {
							_uiStateManager.change('identity_management', {
								identity: result.identity,
								session: result.session,
								renew : _activationData['renew']
							});
						}
					}, errorOccurred);
			}
			function finishRemote(CloudID) {
				let identity = CloudIdentityFactory.create(CloudID.cid, binding, binding.salt());
				_uiStateManager.messageBrokerManager().finish();
				_uiStateManager.change('identity_management', {
					identity: identity,
					"session": _activationData['session'],
					renew : _activationData['renew']
				});
			}
		}
		
		function cryptoAPI_genKey(secret, callback) {
			let salt = Util.randomString(20);
			let key = webcrypto.genKey(webcrypto.ec.c256);			
			let id = webcrypto.saveKey(key, secret);
			let bind = BindingsFactory.createWebCryptoKeyBindingType(secret, salt, id);			
				callback(bind);
		}
		
		function fido_getReg(callback) {
                    _backButton.show();
                    let keyHandle;
                    let challenge = _activationData['session'];
                    let nonce = _activationData.hasOwnProperty('nonce') ? _activationData['nonce'] : Util.randomString(20);
                    let salt = Util.randomString(20);

                    let pvr = webcrypto.hashHex(salt + _bindingView.getInput(), webcrypto.hashAlgo.sha256);
                    challenge = webcrypto.hashBase64url(pvr + nonce + challenge, webcrypto.hashAlgo.sha256);

                    let RegistrationData = {"challenge":challenge,
                                             "appId":window.location.origin,
                                             "version":"U2F_V2"};
                            setTimeout(function(){
                                    window.u2f.register(window.location.origin,[RegistrationData], [],
                                            function(data) {if(data.errorCode) {
                                                            if (data.errorCode === 5 || data.errorCode === 2) {
                                                                    init();
                                                            }
                                                            if (data.errorCode === 2) {
                                                                    _bindingView.disableFIDO();
                                                                    _bindingView.showError(Strings.no_fido_available);
                                                            }
                                                      return;
                                              }
                                              let buff = base64ToArrayBuffer(normal64(data.registrationData));
                                              let dv = new DataView(buff, 0);
                                              let l = dv.getUint8(66);
                                              let h = new Uint8Array(l);
                                              for (let i = 0; i < l; i++) {
                                                            h[i] = dv.getUint8(i+67);
                                                    }
                                            keyHandle = webSafe64(bytes2Base64Native(h));
                                            let bind = BindingsFactory.createFidoU2F(data, nonce, pvr, salt);
                                            callback(bind);
                                      },Configuration.get('FIDO_TIMEOUT'));
                            },200);
		}

		function base64ToArrayBuffer(base64) {
			let binary_string = window.atob(base64);
			let len = binary_string.length;
			let bytes = new Uint8Array(len);
			for (let i = 0; i < len; i++) {
				bytes[i] = binary_string.charCodeAt(i);
			}
			return bytes.buffer;
		}
		function normal64(base64) {
			return base64.replace(/\-/g, '+').replace(/_/g, '/') + '=='.substring(0, (3*base64.length)%4);
		}
		function bytes2Base64Native(rawBytes) {
			let binary = '';
			let bytes = rawBytes;
			let len = bytes.byteLength;
			for (let i = 0; i < len; i++) {
				binary += String.fromCharCode(bytes[i]);
			}
			return window.btoa(binary);
		}
		function webSafe64(base64) {
			return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
		}

		function sendWebCryptoKey (keyBinding, callback) {
			
			let key = webcrypto.loadKey(keyBinding.keyId(), keyBinding.secret());
			let nonce = Util.randomString(20);
			let pvr = webcrypto.hashHex(keyBinding.salt() + keyBinding.secret(), webcrypto.hashAlgo.sha256);
			let toHash = pvr + nonce + _activationData['session'];

			let jws = key.signAndReturnJWS(webcrypto.hashRaw(toHash, webcrypto.hashAlgo.sha256), webcrypto.hashAlgo.sha256);

			let data = new Object();
			let bindData = new Object();

			bindData.sty = "JWS";
			bindData.sig = jws;
			bindData.aux = {};
			bindData.aux.pha = webcrypto.hashAlgo.sha256;
			bindData.pvr = pvr;

			data['bind-type'] = 'http://ws.skidentity.de/ci/binding/key/v1.0';
			data['bind-data'] = JSON.stringify(bindData);
			data['nonce'] = nonce;

			_uiStateManager.messageBrokerManager().sendBinding(data, callback);
		};

		function sendFidoU2F (u2fBinding, callback) {
			let data = new Object();
			let bindData = new Object();

			bindData.sty = "U2F_V2";
			bindData.sig = u2fBinding.registrationData().registrationData;
			bindData.aux = {};
			bindData.aux.typ = "Registration";
			bindData.aux.aid = u2fBinding.registrationData().appId ? u2fBinding.registrationData().appId : window.location.origin;
			bindData.aux.cld = u2fBinding.registrationData().clientData;
			bindData.aux.pha = webcrypto.hashAlgo.sha256;
			bindData.pvr = u2fBinding.pvr();

			data['bind-type'] = 'http://ws.skidentity.de/ci/binding/key/v1.0';
			data['bind-data'] = JSON.stringify(bindData);
			data['nonce'] = u2fBinding.nonce();
			
			_uiStateManager.messageBrokerManager().sendBinding(data, callback);
		};

		function pair() {                                                                
                    _navigationView.update(Strings.transfer_cid);
                    try {
                        _uiStateManager.messageBrokerManager().open(function(message) {
                            _bindingViewContainer.showLoadingIndicator();
                            switch(message.typ){
                                case "Closed":
                                    _bindingViewContainer.hideLoadingIndicator();
                                    break;
                                case "Error":
                                    _bindingViewContainer.hideLoadingIndicator();
                                    let err = new IdsError(ErrorType.RECOVERABLE, "Connection lost", message.message);
                                    errorOccurred({error: err, nextCallback: function() {
                                            _uiStateManager.change('identities_overview');
                                    }});
                                    break;
                                case "PairingData":
                                    _identityTransferView.update(Configuration.get("IDM_URL")+"#pair="+Util.base64Encode(message.adr+
                                                    _uiStateManager.messageBrokerManager().getEndpoint()));
                                    _bindingViewContainer.changeContent(_identityTransferView);
                                    _bindingViewContainer.hideLoadingIndicator();
                                    break;
                                case "Hello":
                                    _bindingViewContainer.hideToLocal();
                                    _bindingViewContainer.hideToMobile();
                                    _bindingViewContainer.hideLoadingIndicator();
                                    _confirmationView.setRemoteAddr(message.adr);
                                    if (_uiStateManager.messageBrokerManager().isMasterIdS()) {
                                        //Set Visual Confirmation and callback for confirm-button
					_bindingViewContainer.showQRHint();
                                        _navigationView.update(Strings.compare_code);
                                        _confirmationView.setInfoText(Strings.please_compare_first);
					_navigationView.setProgress(4);
                                        _confirmationView.setVisualConfimation(message.txt, function() {
                                            _bindingViewContainer.showLoadingIndicator();
                                            //Coninue bindung
                                            _uiStateManager.messageBrokerManager().continueWithLink(function() {
                                                //Finished binding, show instructions
                                                _bindingViewContainer.hideLoadingIndicator();
                                                _navigationView.update(Strings.follow_instructions_title);
                                                _bindingViewContainer.changeContent(_instructionsView);
						_bindingViewContainer.hideQRHint();
                                                //Ask second IDM for binding-data
                                                _uiStateManager.messageBrokerManager().getBinding(_activationData['session'], function(binding) {
                                                    _uiStateManager.core().cloudIdentitiesManager().getCloudIdentity(_activationData['session'], binding['bind-data'], null, function (result) {
                                                        //Send CloudID and wait for 'finish' comand from second IDM
                                                        _bindingViewContainer.showLoadingIndicator();
                                                        _uiStateManager.messageBrokerManager().sendCloudID(result, function() {
                                                                _bindingViewContainer.hideLoadingIndicator();
                                                                _uiStateManager.messageBrokerManager().close();
                                                                transferSuccessful();
                                                        });
                                                    }, errorOccurred, true);
                                                });
                                            });
                                        });
                                    } else {
                                        _confirmationView.setVisualConfimation(message.txt);
                                    }
                                    _bindingViewContainer.changeContent(_confirmationView);
                                    break;
                            }
                        });
                    } catch(e) {
				console.error(e);
                    }
		}
		
		// public methods

		this.title = function () {
			if (_uiStateManager.core().context() === Context.SERVICE_PROVIDER) {
				return _uiStateManager.core().optionsManager().providerInfo().description();
			}

			return _uiStateManager.core().cloudIdentitiesManager().providerInfo().description();
		};
		
		this.poweredByImage = function () {
			if (_uiStateManager.core().optionsManager() === null || _uiStateManager.core().optionsManager() === undefined) {
				return null;
			}
			return _uiStateManager.core().optionsManager().providerInfo().poweredByImage();
		};

		this.content = function () {
			return [ _navigationView, _bindingViewContainer ];
		};

		this.controls = function () {
			return _controlBarView;
		};

		this.enter = function (doneCallback, activationData) {
			
			_activationData = activationData;
			_isRemote = (_activationData.hasOwnProperty('remote') && _activationData['remote']);			
			
			let transfer = StorageUtil.read("transfer");
			if (transfer && transfer) {
				log("enter", "Strating in tranfser mode", transfer);
				StorageUtil.remove("transfer");
				
				_nextButton.hide();
				_bindingViewContainer.showMobileImage();
				_navigationView.setProgress(3);
				pair();
			} else {
				_nextButton.show();
				_bindingViewContainer.changeContent(_bindingView);
			}
			
			if (!_isRemote && !transfer) {
				_bindingViewContainer.showToMobile(toMobile);
			}
                        
                        if (_isRemote) {
                            _navigationView.update(Strings.protect_cid_mobile);
                        }
			
			_providerInfoView.update(
					(_uiStateManager.core().context() === Context.SERVICE_PROVIDER) ?
							_uiStateManager.core().optionsManager().providerInfo() :
								_uiStateManager.core().cloudIdentitiesManager().providerInfo());
			
			
			Util.callCallbacks(doneCallback);
			UiUtil.scrollTo(_navigationView.get());
		};

		this.leave = function (doneCallback) {
			Util.callCallbacks(doneCallback);
		};
	}

	BindingState.prototype = Object.create(UIState.prototype);

	return BindingState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/BindingState.js
// module id = 360
// module chunks = 3